export const CURRENT_FISCAL_YEAR = 'CURRENT_FISCAL_YEAR';
